import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Select,
  Spin,
  notification,
} from "antd";

import React, { useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";

const AddDepartments = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const [loadings, setLoadings] = useState(false);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    setLoadings(true);
    let formData = JSON.stringify({
      code: data.code,
      institutionName: data.name,
      institutionType: data.type,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });
    DepartmentsApi.CreateInstitutions(formData)
      .then((response) => {
        setLoadings(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Successfully</span>,
          description: "Create Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/masters/departments");
      })
      .catch((err) => {
        if (err.apiError.status) {
          setLoadings(false);
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="code"
                    label="Code*"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Code.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Code"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="name"
                    label="Name*"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Department Name.",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Name"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="type"
                    label="Department Type *"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Department Type.",
                      },
                    ]}
                  >
                    <Select
                      className="control-Select mb-1"
                      placeholder="Select Type"
                      options={[
                        { value: "DELI", label: "Deli" },
                        { value: "BUTCHER", label: "Butcher" },
                        { value: "BAKERY", label: "Bakery" },
                        { value: "ICE_CREAM", label: "Ice Cream" },
                        { value: "PRODUCE", label: "Produce" },
                        { value: "SEAFOOD", label: "Seafood" },
                        { value: "CHEESE", label: "Cheese" },
                        { value: "WINE", label: "Wine" },
                        { value: "DELI_SALADS", label: "Deli Salads" },
                        { value: "PASTRY", label: "Pastry" },
                        { value: "COFFEE", label: "Coffee" },
                        { value: "CHOCOLATE", label: "Chocolate" },
                        { value: "SPICES", label: "Spices" },
                        { value: "HONEY", label: "Honey" },
                        { value: "GOURMET", label: "Gourmet" },
                        { value: "PICKLES", label: "Pickles" },
                        { value: "CONDIMENTS", label: "Condiments" },
                        { value: "CATERING", label: "Catering" },
                        { value: "NUTS", label: "Nuts" },
                        { value: "SANDWICHES", label: "Sandwiches" },
                        { value: "BEVERAGES", label: "Beverages" },
                        { value: "DESSERTS", label: "Desserts" },
                        { value: "ORGANIC", label: "Organic" },
                        { value: "ETHNIC", label: "Ethnic" },
                        { value: "GLUTEN_FREE", label: "Gluten-Free" },
                      ]}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <div
                className="d-flex justify-content-between pt-5"
                style={{
                  gap: "10px",
                }}
              >
                <Button
                  onClick={handleGoBack}
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                  }}
                >
                  Back
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  style={{
                    flex: 1,
                    height: 40,
                    borderRadius: 6,
                  }}
                >
                  Save & Continue {loadings && <Spin size="small" className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddDepartments;
